var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.43754 0.240629C9.77857 0.550628 9.77857 1.06657 9.43754 1.37585L3.04065 7.19068L21.1168 7.19646C21.6089 7.19718 22 7.55271 22 8C22 8.4473 21.6089 8.81438 21.1168 8.81438L3.04065 8.8086L9.43754 14.6126C9.77857 14.9334 9.77857 15.4501 9.43754 15.7594C9.08459 16.0802 8.51621 16.0802 8.17597 15.7594L0.264715 8.56797C-0.0882397 8.25797 -0.0882397 7.74203 0.264715 7.43275L8.17597 0.240629C8.517 -0.0802095 9.08459 -0.0802095 9.43754 0.240629Z",
    fill: "#011533"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.511903bc7213a69c76383be94053b7a1.svg";
export { ForwardRef as ReactComponent };